import React from 'react';
import clsx from 'clsx';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ALabel, ALabelSize, ADigit, ADigitSize } from '@marriott/mi-web-ui-kit';

interface MathEquationProps {
  children: React.ReactNode;
  className?: string;
  'aria-label'?: string;
}

export function MathEquation({ children, className, 'aria-label': ariaLabel }: MathEquationProps) {
  return (
    <div
      className={clsx('d-flex align-items-end flex-nowrap gap-3', className)}
      data-testid="cobrand-math-section"
      role={ariaLabel ? 'group' : undefined}
      aria-label={ariaLabel}
    >
      {children}
    </div>
  );
}

interface EqColumnProps {
  label: string;
  value: string;
  isTotal?: boolean;
  isInverse: boolean;
}

export function EqColumn({ label, value, isTotal, isInverse }: EqColumnProps) {
  return (
    <div className="d-flex flex-column gap-1">
      <ALabel size={ALabelSize.S} text={label} className={clsx(isInverse && 't-label-inverse-s', 't-font-weight-r')} />
      <EqValue value={value} isTotal={isTotal} isInverse={isInverse} />
    </div>
  );
}

interface EqValueProps {
  value: string;
  isTotal?: boolean;
  isInverse: boolean;
}

export function EqValue({ value, isTotal, isInverse }: EqValueProps) {
  if (isTotal) {
    return <span className={isInverse ? 't-title-inverse-s' : 't-title-s'}>{value}</span>;
  }
  return <ADigit size={ADigitSize.Medium} text={value} className={isInverse ? 't-numbers-inverse-s' : undefined} />;
}

interface EqOperatorProps {
  operator: '+' | '=';
  isInverse: boolean;
}

export function EqOperator({ operator, isInverse }: EqOperatorProps) {
  return <span className={clsx('align-self-end', isInverse ? 't-numbers-inverse-s' : 't-numbers-s')}>{operator}</span>;
}
